import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectPartnerGeoMarket = createSelector(
  [selectPartner360Data],
  ({ geoMarket }) => geoMarket
)
